/*global google*/

import React from "react";
import { compose, withProps, withStateHandlers } from "recompose";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  InfoWindow
} from "react-google-maps";
import moment from 'moment';
import { Descriptions, Tag, Tooltip } from 'antd';

import _ from 'lodash';

class SignMarker extends React.Component {
  state = { open: false }

  getMarkerColor() {
    const displayed = this.props.sign.displayedString;
    if (displayed === '--') {
      return 'grey';
    } else if (displayed >= 0) {
      return 'green';
    } else {
      return 'red';
    }
  }

  getMarkerNumber() {
    if (this.props.sign.eventListener) {
      const parts = this.props.sign.eventListener.split('/');
      return parts.length > 4 ? parts[4] : '';
    }
    return '';
  }

  getOccStateText() {
    const occState = this.props.sign.occState;
    if (occState === 1) {
      return 'Obsazeno';
    } else if (occState === 0) {
      return 'Volno';
    } else if (occState === -1) {
      return 'Kalibrace / neznámý stav / chyba';
    }
    return 'Neznámý stav';
  }

  render() {
    return (
      <Marker
        icon={{
          path: google.maps.SymbolPath.CIRCLE,
          fillColor: this.getMarkerColor(),
          fillOpacity: 1,
          strokeColor: 'black',
          strokeWeight: 1,
          scale: 12
        }}
        label={{
          text: this.getMarkerNumber(),
          color: 'white',
          fontSize: '12px'
        }}
        position={{
          lng: this.props.sign.coords.coordinates[0],
          lat: this.props.sign.coords.coordinates[1]
        }}
        onClick={() => {
          this.setState({ open: !this.state.open });
        }}
      >
        {this.state.open && (
          <InfoWindow
            onCloseClick={() => {
              this.setState({ open: !this.state.open });
            }}
          >
            <div>
              <h2>{this.props.sign.timerName}</h2>
              <Descriptions layout="vertical" column={1}>
                <Descriptions.Item label="Zobrazený text">
                  {(this.props.sign.displayedString == '--')
                    ? <Tooltip title="Zhasnutá cedule"><Tag color='black'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Tag></Tooltip>
                    : (this.props.sign.displayedString >= 0)
                      ? <Tooltip title="Povolené parkování"><Tag color="green">{this.props.sign.displayedString}</Tag></Tooltip>
                      : <Tooltip title="Parkování přes limit"><Tag color="red">{Math.abs(parseInt(this.props.sign.displayedString))}</Tag></Tooltip>
                  }
                </Descriptions.Item>

                <Descriptions.Item label="Limit">
                  {this.props.sign.timeLimit}
                </Descriptions.Item>

                <Descriptions.Item label="Místo">
                  {this.getMarkerNumber()}
                </Descriptions.Item>

                <Descriptions.Item label="Stav">
                  {this.getOccStateText()}
                </Descriptions.Item>


                <Descriptions.Item label="Poslední změna">
                  {moment(this.props.sign.lastStateChanged).format('LLL')}
                </Descriptions.Item>
              </Descriptions>
            </div>
          </InfoWindow>
        )}
      </Marker>
    )

  }

}

const TimeoutSignsMap = compose(
  withProps({
    googleMapURL: "https://maps.googleapis.com/maps/api/js?key=AIzaSyBm1lrZTw4r-6Z3pkFKfPPs7NHz_RGHg6Y&v=3.exp&libraries=geometry,drawing,places",
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `600px` }} />,
    mapElement: <div style={{ height: `100%` }} />
  }),
  withScriptjs,
  withGoogleMap
)(props => (
  <GoogleMap
    ref={props.onMapMounted}
    zoom={props.zoom}
    center={props.center}
  >
    {props.signs.map(sign => {
      return (
        <SignMarker key={sign.id} sign={sign} />
      );
    })}

  </GoogleMap>
));

export default TimeoutSignsMap;



// WEBPACK FOOTER //
// ./src/components/TimeoutSignsMap.js